import Countdown from "./Countdown";
import { t } from "../i18n";

// Shows a countdown to the SOONEST same-day window cut-off (the next window to close).
// Falls back to the legacy single cut-off when per-window data is absent.
const SameDayCountdown = ({ sd, timing, locale, city }) => {
  const openWins = (sd?.windows || []).filter((w) => w.open);
  const soonest = openWins.reduce((a, b) => (a && a.seconds_remaining < b.seconds_remaining ? a : b), null);
  const anyOpen = sd ? sd.any_open : timing?.same_day_open;
  if (anyOpen) {
    const secs = soonest ? soonest.seconds_remaining : timing?.seconds_remaining;
    return (
      <span data-testid="same-day-countdown">
        {t(locale, "cutoffIn")} <Countdown seconds={secs} /> {t(locale, "forDeliveryToday")} {city}
        {soonest ? <span className="opacity-80"> · {t(locale, soonest.key).split(" ")[0]}</span> : null}
      </span>
    );
  }
  return <span data-testid="same-day-closed">{t(locale, "closedToday")}</span>;
};

export default SameDayCountdown;
